import { ChangeDetectionStrategy, Component, InjectionToken } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as pako from 'pako';

export const PDF_DATA = new InjectionToken<unknown>('PDF_DATA');

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-pdf-page',
  templateUrl: './pdf-page.component.html',
  standalone: false,
  providers: [
    {
      provide: PDF_DATA,
      useFactory: (activateRoute: ActivatedRoute) => {
        try {
          const rawData = activateRoute.snapshot.queryParamMap.get('data');
          if (rawData) {
            const bufferData = Uint8Array.from(atob(decodeURIComponent(rawData)), c => c.charCodeAt(0));
            const decodedData = JSON.parse(pako.inflate(bufferData, { to: 'string' }), (_key, value) => {
              if (typeof value === 'string') {
                const a = /\/Date\((\d*)\)\//.exec(value);
                if (a) return new Date(+a[1]);
              }
              return value;
            });
            return decodedData;
          }
          return null;
        } catch (error) {
          console.error('Failed to decode PDF_DATA:', error);
          return null;
        }
      },
      deps: [ActivatedRoute],
    },
  ],
})
export class PDFPageComponent {}
